
































import Vue from "vue";
import Component from "vue-class-component";
import {i18n} from "@/plugins/i18n";
import {TableHeader} from "@/plugins/vuetify";
import {providersModule} from "@/store/store";

@Component
export default class ProvidersView extends Vue {

    headers: TableHeader[] = [
        {value: "name", text: i18n.t("views.providers.list.name") as string},
        {value: "email", text: i18n.t("views.providers.list.email") as string},
        {value: "phoneNumber", text: i18n.t("views.providers.list.phone-number") as string},
        {value: "websiteUrl", text: i18n.t("views.providers.list.website-url") as string},
        {value: "actions", text: i18n.t("views.providers.list.actions") as string, sortable: false},
    ];

    filter: string = "";

    stopProviderSync!: () => void;

    get providers() {
        return providersModule.providers;
    }

    get providersModule() {
        return providersModule;
    }

    mounted() {
        this.stopProviderSync = providersModule.syncProviders();
    }

    destroyed() {
        this.stopProviderSync();
    }

}
